import React from 'react';
import Link from '@material-ui/core/Link';

import { USER_PANEL_TYPES, } from './index';
import { layout, } from 'styles';
import SvgIcon from 'common/components/SvgIcon';
import loginIcon from 'assets/icons/icon_login_on.svg';
import { MOJE_GWO_LINK, LOGOUT_LINK, } from 'common/constants';

type Props = {
    type: USER_PANEL_TYPES,
};

const userPanelVariants = {
    [USER_PANEL_TYPES.USER_ACTION]: {
        label: 'Wyloguj',
        href: LOGOUT_LINK,
    },
    [USER_PANEL_TYPES.USER_LINK]: {
        label: 'Moje GWO',
        href: MOJE_GWO_LINK,
    },
};

const UserPanelItem: React.FC<Props> = ({
    type,
}) => {
    const { item, } = layout.makeUserPanelStyles({ type, });
    const { label, href, } = userPanelVariants[type];

    return (
        <Link href={href ?? '#'}
              className={item}>
            {USER_PANEL_TYPES.USER_ACTION === type && <SvgIcon src={loginIcon} />} {label}
        </Link>
    );
};

export default UserPanelItem;
